import React from 'react';
import Styles from './styles.module.scss';
import { TextContainer, Heading, Card, Stack, Subheading, TextStyle, Badge, Button } from '@shopify/polaris';

const ThemeLibrary = props => {
  return (<>
    <div className="row">
      <div className="cl-3">
        <TextContainer>
          <Heading element="h5">Theme library</Heading>
          <p>Manage your store's theme. Add and publish themes to change your online store's appearance.</p>
        </TextContainer>
      </div>
      <div className="cl-9">
        <Card sectioned>
          <Card.Section>
            <div className={`${Styles['container']} d-flex justify-content-between`}>
              <div className={`${Styles['left-container']} d-flex align-items-center`}>
                <TextStyle variation="strong">Shopify prestige plugin</TextStyle>
                <Badge status="info"><TextStyle variation="strong">LIVE</TextStyle></Badge>
              </div>
              <div className={`${Styles['right-container']} d-flex`} >
                <Button outline disabled>Installed</Button>
                <div className="">
                  <div onClick={() => { }}
                    className={'switch-wrapper ' + ('on')}>
                    <div className="is on">
                      On
                     <div className="is off">off</div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </Card.Section>
          <Card.Section>
            <div className={`${Styles['container']} d-flex justify-content-between`}>
              <div className={`${Styles['left-container']} d-flex align-items-center`}>
                <TextStyle variation="strong">Debut</TextStyle>
              </div>
              <div className={`${Styles['right-container']} d-flex`} >
                <Button outline disabled>Installed</Button>
              </div>
            </div>
          </Card.Section>
          <Card.Section>
            <div className={`${Styles['container']} d-flex justify-content-between`}>
              <div className={`${Styles['left-container']} d-flex align-items-center`}>
                <TextStyle variation="strong">Minimal</TextStyle>
              </div>
              <div className={`${Styles['right-container']} d-flex`} >
                <Button outline disabled>Installed</Button>
              </div>
            </div>
          </Card.Section>

        </Card>
      </div>
    </div>
  </>)
}


export default ThemeLibrary;